import { Link, useRouter } from '@tanstack/react-router';

import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  const router = useRouter();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-foreground">404</h1>
        <p className="mt-4 text-xl text-muted-foreground">
          Oops! The page you're looking for doesn't exist.
        </p>
        <p className="mt-2 text-sm text-muted-foreground">
          The page might have been moved, deleted, or you entered the wrong URL.
        </p>
        <div className="mt-8 flex gap-4 justify-center">
          <Button onClick={() => router.history.back()} variant="outline">
            Go Back
          </Button>
          <Link to="/">
            <Button>Go Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
